import {Component, OnInit, Inject, NgZone, OnDestroy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MdKanbanFormChequeDepotDialogComponent } from '../md-kanban-form-cheque-depot-dialog/md-kanban-form-cheque-depot-dialog.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MdKanbanFormChequeRetraitDialogComponent } from '../md-kanban-form-cheque-retrait-dialog/md-kanban-form-cheque-retrait-dialog.component';
import { MdKanbanFormFactureDepotDialogComponent } from '../md-kanban-form-facture-depot-dialog/md-kanban-form-facture-depot-dialog.component';
import { Subject } from 'rxjs';
import { KANBAN_TYPE_FACTURATION, KANBAN_TYPE_TASK } from '../../../kanban.model';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'md-kanban-form-add-task-dialog',
    templateUrl: './md-kanban-form-add-task-dialog.component.html',
})
export class MdKanbanFormAddTaskDialogComponent implements OnInit {
    loading = false;
    taskForm = this._formBuilder.group({
        ID: [null],
        TYPE_TASK: [KANBAN_TYPE_TASK.DEPOT_CHEQUE, Validators.required],
        PARAMS_TASK: [null]
    });
    KANBAN_TYPE_TASK = KANBAN_TYPE_TASK;
    KANBAN_TYPE_FACTURATION = KANBAN_TYPE_FACTURATION;
    onTasksAdded$ = new Subject();
    kanbanItem: any;
    startupInfos: any;

    constructor(
        private _dialog: MatDialog,
        private _formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<MdKanbanFormAddTaskDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: { kanbanItem: any; startupInfos: any },
    ) {
        this.kanbanItem = data.kanbanItem;
        this.startupInfos = data.startupInfos;
    }

    ngOnInit() {
    }

    dismiss() {
        this.dialogRef.close();
    }

    get f() {
        return this.taskForm.controls;
    }

    async onSubmit() {
        if (this.f.TYPE_TASK.value == KANBAN_TYPE_TASK.DEPOT_CHEQUE) {
            await this.doOpenFormChequeDepotDialog();
        } else if (this.f.TYPE_TASK.value == KANBAN_TYPE_TASK.RETRAIT_CHEQUE) {
            await this.doOpenFormChequeRetraitDialog();
        } else if (this.f.TYPE_TASK.value == KANBAN_TYPE_TASK.DEPOT_FACTURE) {
            await this.doOpenFormFactureDepotDialog();
        }
    }

    private async doOpenFormChequeDepotDialog() {
        const resultDialog = await this._dialog.open(MdKanbanFormChequeDepotDialogComponent, {
            data: { kanbanItem: this.kanbanItem, startupInfos: this.startupInfos},
            width: '100vw',
            panelClass: 'datasource-designer-modal'
        }).afterClosed().toPromise();
        if (!!resultDialog) {
            if (!!resultDialog.data) {
                this.taskForm.controls.PARAMS_TASK.patchValue(resultDialog.data);
                this.onTasksAdded$.next([this.taskForm.value]);
            }
            this.dialogRef.close();
        }
    }

    private async doOpenFormChequeRetraitDialog() {
        const resultDialog = await this._dialog.open(MdKanbanFormChequeRetraitDialogComponent, {
            data: { kanbanItem: this.kanbanItem, startupInfos: this.startupInfos},
            width: '100vw',
            panelClass: 'datasource-designer-modal'
        }).afterClosed().toPromise();
        if (!!resultDialog) {
            if (!!resultDialog.data) {
                this.taskForm.controls.PARAMS_TASK.patchValue(resultDialog.data);
                this.onTasksAdded$.next([this.taskForm.value]);
            }
            if (resultDialog.renew == true) {
                this.doOpenFormChequeRetraitDialog();
            } else {
                this.dialogRef.close();
            }
        }
    }

    private async doOpenFormFactureDepotDialog() {
        const resultDialog = await this._dialog.open(MdKanbanFormFactureDepotDialogComponent, {
            data: { kanbanItem: this.kanbanItem, startupInfos: this.startupInfos},
            width: '100vw',
            panelClass: 'datasource-designer-modal'
        }).afterClosed().toPromise();
        if (!!resultDialog) {
            if (!!resultDialog.data?.length) {
                const tasks = resultDialog.data.map(paramsTask => ({
                    ID: null,
                    TYPE_TASK: this.f.TYPE_TASK.value,
                    PARAMS_TASK: paramsTask
                }));
                this.onTasksAdded$.next(tasks);
            }
            if (resultDialog.renew == true) {
                this.doOpenFormFactureDepotDialog();
            } else {
                this.dialogRef.close();
            }
        }
    }
}